export class ListView {
	constructor(element) {
		this.View = element;

		this.OnOpenLink = null;
	}

	Search(query) {
		const items = [...this.View.querySelectorAll(".list-view-item")];

		if (items.length) {
			const newSet = items.search(query, "textContent", -1);

			items.forEach(item => {
				item.toggleClass("d-none", !newSet.includes(item) && query.trim() !== "");

				if (item.classList.contains("d-none")) {
					item.removeClass("active");
				}
			});

			this.View.querySelectorAll(".collapse").forEach(collapser => {
				const hide = !collapser.querySelector(".list-view-item:not(.d-none)");

				collapser.toggleClass("d-none", hide);
				document.querySelector(`[data-bs-target='#${collapser.id}']`)?.toggleClass("d-none", hide);
			});
		}
	}

	static RefreshListViews() {
		document.querySelectorAll(".list-view").forEach(x => x.ListView ??= new ListView(x));
	}
}